import axios from 'axios';
import { Payer } from '../models/payer';

export const getPayers = async (ids: number[]): Promise<Payer[]> => {
    const response = await axios.post(`/api/payer`, ids);
    return response.data;
};

export const getOtherPayers = async (ids: number[]): Promise<Payer[]> => {
    const response = await axios.post(`/api/payer/other`, ids);
    return response.data;
};
